import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import authStore from './modules/authentication';
import searchStore from './modules/search';
import { isTestEnv, profileSectionURLs } from '../config/oidc';

Vue.use(Vuex);

const THEME_DATA_LIST = "https://webdist.data.apnic.net/lists/theme-v1.json";

export default new Vuex.Store({
	state: {
		themeDataList: {}
	},
	mutations: {
		setThemeDataList: (state, data) => {
			state.themeDataList = data;
		},
	},
	actions: {
		fetchThemeDataList: (context) => {
			axios
				.get(THEME_DATA_LIST)
				.then((res) => {
					const themeDataList = res.data;

					if (isTestEnv) {
						// Replace omnibarCurrentUserAccountLinks and omnibarCurrentUserMembershipLinks links
						// in the theme  data list to the test urls
						const omnibarCurrentUserAccountLinksUpdated =
							themeDataList.omnibarCurrentUserAccountLinks.map((item) => {
								switch (item.label_en_us) {
									case 'MyAPNIC':
										item.link = profileSectionURLs.myApnicDashboardURL;
										break;
									case 'Personal profile':
										item.link = profileSectionURLs.personalSettingsURL;
										break;
									case 'Passwords & Security':
										item.link = profileSectionURLs.passwordSecurityURL;
										break;
									default:
										break;
								}
								return item;
							});

						const omnibarCurrentUserMembershipLinksUpdated =
							themeDataList.omnibarCurrentUserMembershipLinks
								// Filter out "Log out" in the theme data list because it is
								// handled separately by logout() in NavBar.vue
								.filter((item) => item.label_en_us !== 'Log out')
								.map((item) => {
									switch (item.label_en_us) {
										case 'Link existing membership':
											item.link = profileSectionURLs.linkExistingMembership;
											break;
										case 'New membership application':
											item.link = profileSectionURLs.membershipApplication;
											break;
										default:
											break;
									}
									return item;
								});

						const themeDataListUpdated = {
							...themeDataList,
							omnibarCurrentUserAccountLinks: omnibarCurrentUserAccountLinksUpdated,
							omnibarCurrentUserMembershipLinks: omnibarCurrentUserMembershipLinksUpdated,
						};

						context.commit('setThemeDataList', themeDataListUpdated);
					} else {
						// Use the default theme data list in production
						context.commit('setThemeDataList', themeDataList);
					}
				})
				.catch((err) => {
					console.error("Failed to fetch theme data list: " + err);
				});
		},
	},
	modules: {
		authStore,
		searchStore
	}
});
